import React, { useEffect, useState, useCallback } from 'react';
import { initializeIcons } from '@uifabric/icons';
import { connect, useDispatch, useSelector } from 'react-redux';

import { IRootState } from 'reducer';

import { GlobalStyle } from 'globalStyles';
import { BCNavigation, Navigation } from 'views/pages/Cordova/Navigation';
import { Redirect, Route, Switch } from 'react-router-dom';
import { MapPage } from 'views/pages/Cordova/MapPage';
import { bcContext, mainCordovaContext } from './context';
import { actions as appActions } from 'reducer/app';
import AuthPage from '../AuthPage';
import { Video } from './Video';
import { ControllerTask } from './ControllerTask';
import Filters from './Filters';
import { Handbooks, HandbookPage } from './Handbooks';
import { Task } from '../ControllerTask/Details/Details.types';
import { BCResult } from './BCResult';
import { BCCurrentRegion } from './BCCurrentRegion';
import { MapModes } from './MapPage/MapPage.types';
import { NoConnection } from './NoConnectionPage';
import { About } from './About';
import { useHistory } from 'react-router';
import { ClientError } from './ClientError';
import CustomSpinner from '../../components/UI/Spinner';
import { AccessDenied } from './AccessDenied';

initializeIcons();

const App = () => {
  // const [showNavigation, setShowNavigation] = useState(false);
  const [task, setTask] = useState<Task | null>(null);

  const isInitializing = useSelector<IRootState, boolean>(
    (state) => state.app.isInitializing
  );

  const isLogged = useSelector<IRootState, boolean>(
    (state) => state.user.isLogged
  );

  const dispatch = useDispatch();

  useEffect(() => {
    const setVh = () =>
      document.documentElement.style.setProperty(
        '--vh',
        `${window.innerHeight / 100}px`
      );

    window.addEventListener('resize', setVh);
    window.addEventListener('orientationchange', setVh);

    setVh();
  }, []);

  useEffect(() => {
    if (localStorage.getItem('token')) {
      dispatch(appActions.performInitialAppLoading());
    }
  }, [dispatch]);

  const history = useHistory();

  const toggleNavigation = useCallback(() => {
    const showNavigation =
      new URLSearchParams(history.location.search).get('navState') === 'open';
    if (!showNavigation) {
      history.push('?navState=open');
      //   setShowNavigation(value);
      // } else {
      //   setShowNavigation((prev) => !prev);
    }
  }, [history]);

  if (isInitializing) return <CustomSpinner />;

  let content = (
    <>
      <Navigation />

      <Switch>
        <Route path="/no-connection" component={NoConnection} />
        <Route path="/access-denied" component={AccessDenied} />
        <Route
          path="/map"
          render={({ location }) => (
            <MapPage key={location.pathname} mode={MapModes.default} />
          )}
        />
        <Route path="/video/:vehicle" component={Video} />
        <Route path="/video" component={Filters} />
        <Route
          path="/bc/departmentcontroll"
          render={({ location }) => (
            <MapPage
              key={location.pathname}
              mode={MapModes.departmentControl}
            />
          )}
        />
        <Route path="/bc/controllertask" component={ControllerTask} />
        <Route path="/bc/result" component={BCResult} />
        <Route path="/bc/currentregion" component={BCCurrentRegion} />
        <Route path="/bc" component={BCNavigation} />
        <Route path="/about" component={About} />
        <Route path="/handbooks/:type/:id" component={HandbookPage} />
        <Route path="/handbooks/:type" component={HandbookPage} />
        <Route path="/handbooks/" component={Handbooks} />
      </Switch>
    </>
  );

  if (!isLogged /*&& !(window as any).cordova*/) {
    content = <AuthPage />;
  }

  return (
    <mainCordovaContext.Provider
      value={{
        toggleNavigation,
      }}
    >
      <bcContext.Provider
        value={{
          setTask,
          task,
        }}
      >
        <GlobalStyle />
        {content}
      </bcContext.Provider>
    </mainCordovaContext.Provider>
  );
};

type State = { error: (Error & React.ErrorInfo) | null };

class CatchErrorWrapper extends React.Component<{}, State> {
  state: State = {
    error: null,
  };

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    this.setState({
      error: {
        message: error.message,
        name: error.name,
        stack: error.stack,
        componentStack: errorInfo.componentStack,
      },
    });
  }

  render() {
    if (this.state.error) {
      return (
        <ClientError
          onClose={() => this.setState({ error: null })}
          error={this.state.error}
        />
      );
    }
    return <App />;
  }
}

export default CatchErrorWrapper;
